<template>
  <teleport to="body">
    <Transition name="create-bill-progressor">
      <div
        v-if="show"
        class="create-bill-progressor-overlay create-bill-progressor-overlay--glass"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
      >
        <div class="create-bill-progressor-dialog create-bill-progressor-dialog--glass" @click.stop>
          <h2 :id="titleId" class="create-bill-progressor-title">{{ progressTitle }}</h2>
          <p class="create-bill-progressor-subtitle">
            {{ progressSubtitle }}
          </p>
          <ul class="create-bill-progressor-steps">
            <li
              v-for="(s, index) in steps"
              :key="s.key"
              class="create-bill-progressor-step"
              :class="'create-bill-progressor-step--' + (s.status || 'pending')"
              :style="{ '--cbp-step-delay': `${0.18 + index * 0.07}s` }"
            >
              <div class="create-bill-progressor-step-icon-wrap">
                <span
                  v-if="s.status === 'active'"
                  class="create-bill-progressor-step-icon--spin"
                  aria-hidden="true"
                />
                <span v-else class="create-bill-progressor-step-icon" aria-hidden="true">{{
                  iconFor(s.status)
                }}</span>
              </div>
              <div class="create-bill-progressor-step-body">
                <span class="create-bill-progressor-step-label">{{ s.label }}</span>
                <span v-if="s.detail" class="create-bill-progressor-step-detail">{{ s.detail }}</span>
              </div>
            </li>
          </ul>
          <Transition name="create-bill-progressor-foot">
            <p
              v-if="footMessage"
              class="create-bill-progressor-foot"
              :class="footClass"
            >
              {{ footMessage }}
            </p>
          </Transition>
          <div class="create-bill-progressor-actions">
            <button
              type="button"
              class="create-bill-progressor-ok"
              :disabled="!okEnabled"
              @click="$emit('ok')"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </teleport>
</template>

<script>
import './CreateBillProgressor.css';

let createBillProgressorTitleSeq = 0;

export default {
  name: 'CreateBillProgressor',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    okEnabled: {
      type: Boolean,
      default: false,
    },
    footMessage: {
      type: String,
      default: '',
    },
    footTone: {
      type: String,
      default: 'neutral',
      validator: (v) => ['neutral', 'success', 'warn'].includes(v),
    },
    progressTitle: {
      type: String,
      default: 'Create bill progress',
    },
    progressSubtitle: {
      type: String,
      default:
        'Saving the bill and posting the journal entry run in order. When every step is finished, click OK to complete.',
    },
  },
  emits: ['ok'],
  data() {
    return {
      titleId: `create-bill-progressor-title-${++createBillProgressorTitleSeq}`,
    };
  },
  computed: {
    footClass() {
      if (this.footTone === 'success') return 'create-bill-progressor-foot--success';
      if (this.footTone === 'warn') return 'create-bill-progressor-foot--warn';
      return '';
    },
  },
  methods: {
    iconFor(status) {
      if (status === 'done') return '✓';
      if (status === 'error') return '✕';
      if (status === 'skipped') return '–';
      return '○';
    },
  },
};
</script>
